// src/hooks/queries/useSupport.ts
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  supportApi,
  CreateTicketPayload,
  CreateMessagePayload,
} from "../../api/support.api";

export const useMyTickets = (page: number = 0) => {
  return useQuery({
    queryKey: ["support-tickets", page],
    queryFn: () => supportApi.getMyTickets(page),
  });
};

export const useTicketDetails = (ticketId: string | null) => {
  return useQuery({
    queryKey: ["support-ticket", ticketId],
    queryFn: () => supportApi.getTicketDetails(ticketId!),
    enabled: !!ticketId,
  });
};

export const useCreateTicket = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateTicketPayload) =>
      supportApi.createTicket(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["support-tickets"] });
    },
  });
};

export const useAddTicketReply = (ticketId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateMessagePayload) =>
      supportApi.addReply(ticketId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["support-ticket", ticketId] });
      queryClient.invalidateQueries({ queryKey: ["support-tickets"] });
    },
  });
};
